<!-- <div class="form-group col-xs-12 col-sm-12"> -->
<ng-template [ngIf]="!fileUploaded"> <input #fileInput
	type="file" class="filestyle" [(ngModel)]="_value"
	(change)="onChangeUpload($event, t)" data-icon="false"
	data-buttontext="Allega" id="{{ inputId + '_' + randomValueString}}"
	tabindex="-1"
	style="position: absolute; clip: rect(0px, 0px, 0px, 0px);">
<div class="bootstrap-filestyle input-group" ngbTooltip=""
	triggers="manual" #t="ngbTooltip"
	(onUploadError)='errorCallback($event, t)'>
	<input [disabled]="true" type="text" class="form-control"> <span
		class="group-span-filestyle input-group-btn" tabindex="0"><label
		for="{{ inputId  + '_' + randomValueString}}" class="btn btn-default "><span
			class="buttonText">{{ buttonText }}</span></label></span>
</div>
</ng-template>
<ng-template [ngIf]="fileUploaded">
<div class="row">
	<p class="col-sm-11 form-group">
		<label for="documento_all">Documento allegato</label> <input
			name="documento_all" disabled value="{{ fileUploadedName }}"
			type="text" class="form-control">
	</p>
	<p class="form-group col-sm-1 larger">
		<a href="javascript:void(0)" (click)="deleteFile()"><span
			class="glyphicon glyphicon-remove-circle"></span></a>
	</p>
</div>
</ng-template>
<!-- </div> -->